
//* LE TRANSPORT DE LA DOUCE *// 
import React from "react";
import Home from "./pages/Home";
import "./styles/global.css";

function App() {
  return <Home />;
}

export default App;


